import React, { useState } from 'react';
import Sidebar from '../Components/Sidebar';
import MobileNav from '../Components/MobileNav'; // ADD THIS
import { useIsMobile } from '../hooks/useMediaQuery'; // ADD THIS

export default function About() {
  const isMobile = useIsMobile(); // ADD THIS
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div style={{ 
      display: 'flex', 
      background: '#020617', 
      minHeight: '100vh', 
      color: 'white',
      flexDirection: isMobile ? 'column' : 'row',
    }}>
      {!isMobile && <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />}

      <div style={{ 
        flex: 1, 
        marginLeft: isMobile ? '0' : (collapsed ? '80px' : '280px'),
        padding: isMobile ? '16px' : '40px',
        paddingBottom: isMobile ? '90px' : '40px',
        transition: 'margin-left 0.3s ease',
        overflowX: 'hidden',
      }}>
        <h1 style={{
          fontSize: isMobile ? '24px' : '32px',
          marginBottom: isMobile ? '16px' : '20px',
          fontWeight: 'bold',
        }}>
          About WWMMCGC
        </h1>

        <div style={{ 
          marginTop: isMobile ? '16px' : '20px', 
          lineHeight: '1.8',
          fontSize: isMobile ? '15px' : '16px',
        }}>
          <h3 style={{ 
            marginTop: isMobile ? '20px' : '25px',
            fontSize: isMobile ? '18px' : '20px',
            color: '#38bdf8',
            marginBottom: '10px',
          }}>
            What is WWMMCGC?
          </h3>
          <p style={{ color: '#94a3b8', lineHeight: '1.7' }}>
            WWMMCGC (World Wide Mini Militia Classic Global Community) is a global
            gaming community built to connect Mini Militia players worldwide.
            It provides a platform for players to showcase their profiles,
            follow other gamers, and build strong competitive clans.
          </p>

          <h3 style={{ 
            marginTop: isMobile ? '20px' : '25px',
            fontSize: isMobile ? '18px' : '20px',
            color: '#38bdf8',
            marginBottom: '10px',
          }}>
            Our Mission
          </h3>
          <p style={{ color: '#94a3b8', lineHeight: '1.7' }}>
            To unite Mini Militia players across the globe and create
            a competitive, respectful, and fun environment for everyone.
          </p>

          <h3 style={{ 
            marginTop: isMobile ? '20px' : '25px',
            fontSize: isMobile ? '18px' : '20px',
            color: '#38bdf8',
            marginBottom: '10px',
          }}>
            Our Vision
          </h3>
          <p style={{ color: '#94a3b8', lineHeight: '1.7' }}>
            To become the largest and most organized Mini Militia
            community platform and expand into other competitive gaming networks.
          </p>
        </div>
      </div>
      
      {isMobile && <MobileNav />}
    </div>
  );
}